export default {
  currentUser: state => state.currentUser
}
